import ReportMTTR from '@/models/ReportMTTR/ReportMTTR';

export default class ReportMTTRFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.filterPeriodDateFrom = '';
		this.filterPeriodDateTo = '';
		this.filterLotNo = '';
		this.filterStartDateFrom = '';
		this.filterStartDateTo = '';
		this.filterFinishDateFrom = '';
		this.filterFinishDateTo = '';
		this.filterMachineCode = '';
		this.tempId = '';
		this.woDate = '';
		this.lotNo = '';
		this.standarTimeName = '';
		this.startProductionFrom = '';
		this.startProductionTo = '';
		this.finishProductionFrom = '';
		this.finishProductionTo = '';
		this.code = '';
		this.woeId = '';
		this.troubleReport = '';
		this.analisaDanPenyebab = '';
		this.tindakan = '';
		this.eksIn = '';
		this.pic = '';
		this.hourMinuteStart = '';
		this.hourMinuteEnd = '';
		this.differenceHhMm = '';
		this.totalMinutes = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			filterPeriodDateFrom : '0',
			filterPeriodDateTo : '0',
			filterLotNo : '0',
			filterStartDateFrom : '0',
			filterStartDateTo : '0',
			filterFinishDateFrom : '0',
			filterFinishDateTo : '0',
			filterMachineCode : '0',
			tempId : '0',
			woDate : '0',
			lotNo : '0',
			standarTimeName : '0',
			startProductionFrom : '0',
			startProductionTo : '0',
			finishProductionFrom : '0',
			finishProductionTo : '0',
			code : '0',
			woeId : '0',
			troubleReport : '0',
			analisaDanPenyebab : '0',
			tindakan : '0',
			eksIn : '0',
			pic : '0',
			hourMinuteStart : '0',
			hourMinuteEnd : '0',
			differenceHhMm : '0',
			totalMinutes : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}